import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { useHistory, useLocation } from 'react-router-dom'
import Bagni from '../component/Bagni';
import NavBar from '../component/NavBar';
import ReactGA from "react-ga4";

const BagnoPage = () => {

    const history = useHistory();
    const location = useLocation();
    ReactGA.send({ hitType: "pageview", page: "/bagno", title: "Bagno" });
   
    const [preventivo, setPreventivo] = useState(location.state?.preventivo ||
        {
            bagni: []
        }
    );

    const handleCalcolo = () => {

        history.push("/preventivo", { preventivo: preventivo, editURL: '/bagno' })
    }

    return (
        <div >
            <NavBar />
            <>
                <div className="surface-ground px-1 py-1 md:px-4 md:py-4 ">
                    <div className='flex gap-4 pr-4'>
                        <div className='flex flex-grow-1 flex-column'>
                            <div className="text-900 font-medium text-900 text-xl mb-2">Bagno</div>
                            <p className="m-0 mb-2 p-0 text-600 line-height-3 mr-3">Descrizione preventivo bagno</p>
                        </div>
                        <div className='flex-grow-0'>
                            <Button label="Genera preventivo" className="w-auto mt-3" onClick={handleCalcolo} />
                        </div>
                    </div>

                    <Bagni preventivo={preventivo}
                        onChange={(data) => setPreventivo({ ...preventivo, bagni: data })} />
                    <div className="col-12">
                    </div>

                </div>
            </>
        </div>


    )

}

export default BagnoPage